module.exports = __webpack_public_path__ + "static/media/red-no.4603197b.svg";